import React, { memo } from "react"

const CheckIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="20 6 9 17 4 12" />
    </svg>
)

const WhyChooseVisiomateforD365 = ({ data, style }) => {
    return (
        <div className="prod-why" style={style}>
            <h2 className="prod-why__title">{data.title}</h2>
            <div className="prod-why__grid">
                {data.headings.map((d, index) => (
                    <div key={index} className="prod-why__card">
                        <div className="prod-why__card-icon">
                            <CheckIcon />
                        </div>
                        <div className="prod-why__card-body">
                            <h3 className="prod-why__card-heading">{d.heading}</h3>
                            <p className="prod-why__card-desc">{d.description}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}
export default memo(WhyChooseVisiomateforD365)
